// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2ybiO","cancelBtn":"Modal_cancelBtn__3Jz7h","modalContainer":"Modal_modalContainer__1awhw"};